import Blocks from '@component/Blocks';
import EntryIndex from '@component/EntryIndex';
import Container from '@componentPrimitives/Container';
import { SearchResultCard } from '@components/EntryCard';
import { EntryIndexScrollTop } from '@components/EntryIndex/EntryIndex.ScrollTop';
import { EntrySummary } from '@components/PageHeader/EntrySummary';
import { PageHeaderRoot } from '@components/PageHeader/PageHeaderRoot';
import { useEntryIndex } from '@lib/features/entryIndexes';
import { toString } from 'lodash';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/router';
import React from 'react';
import SearchForm from './SearchForm';

const SearchIndexInner = () => {
  const r = useRouter();
  const resultsRef = React.useRef<HTMLDivElement>(null);
  const urlQuery = r?.query?.query ? toString(r?.query?.query) : undefined;

  console.log({ query: r.query });

  const { query } = useEntryIndex(({ entryCount, args: { query }, isLoading, entries }) => ({
    entryCount,
    query,
    isLoading,
    entries,
  }));

  const hasQuery = !!query?.length;

  return (
    <>
      <PageHeaderRoot variant="overview" colorSet="secondary" paper>
        <EntrySummary />
        <SearchForm term={urlQuery} showCount showSpinner />
      </PageHeaderRoot>
      <EntryIndexScrollTop />
      {hasQuery && (
        <Container ref={resultsRef} cx={{ mY: '2xl' }}>
          <EntryIndex.Grid CardGridProps={{ Component: SearchResultCard }} />
          <EntryIndex.Pagination />
        </Container>
      )}
    </>
  );
};

const SearchIndex = () => {
  return (
    <>
      <EntryIndex indexKey="search">
        <SearchIndexInner />
      </EntryIndex>
      <Blocks />
    </>
  );
};

export default SearchIndex;
